export const TYPE_CPF = 1
export const TYPE_CNPJ = 2

export const ORIGIN_WEB = "WEB"
export const ORIGIN_MOBILE = "MOBILE"

export const COMPANY_TYPES = [
  { value: 1, text: "Empresa LTDA" },
  { value: 2, text: "Sociedade Anônima" },
  { value: 3, text: "Sindicatos, Cooperativas e Associações" },
  { value: 4, text: "Firma Individual" },
  { value: 5, text: "Igrejas" },
  { value: 6, text: "Condomínio" },
  { value: 7, text: "Produtor Rural" }
]

export const STATES = [
  { value: 0, text: "Selecione...", acronym: "" },
  { value: 1, text: "Acre", acronym: "AC" },
  { value: 2, text: "Alagoas", acronym: "AL" },
  { value: 3, text: "Amazonas", acronym: "AM" },
  { value: 4, text: "Amapá", acronym: "AP" },
  { value: 5, text: "Bahia", acronym: "BA" },
  { value: 6, text: "Ceará", acronym: "CE" },
  { value: 7, text: "Distrito Federal", acronym: "DF" },
  { value: 8, text: "Espírito Santo", acronym: "ES" },
  { value: 9, text: "Goiás", acronym: "GO" },
  { value: 10, text: "Maranhão", acronym: "MA" },
  { value: 11, text: "Minas Gerais", acronym: "MG" },
  { value: 12, text: "Mato Grosso do Sul", acronym: "MS" },
  { value: 13, text: "Mato Grosso", acronym: "MT" },
  { value: 14, text: "Pará", acronym: "PA" },
  { value: 15, text: "Paraíba", acronym: "PB" },
  { value: 16, text: "Pernambuco", acronym: "PE" },
  { value: 17, text: "Piauí", acronym: "PI" },
  { value: 18, text: "Paraná", acronym: "PR" },
  { value: 19, text: "Rio de Janeiro", acronym: "RJ" },
  { value: 20, text: "Rio Grande do Norte", acronym: "RN" },
  { value: 21, text: "Rondônia", acronym: "RO" },
  { value: 22, text: "Roraima", acronym: "RR" },
  { value: 23, text: "Rio Grande do Sul", acronym: "RS" },
  { value: 24, text: "Santa Catarina", acronym: "SC" },
  { value: 25, text: "Sergipe", acronym: "SE" },
  { value: 26, text: "São Paulo", acronym: "SP" },
  { value: 27, text: "Tocantins", acronym: "TO" }
]

export const PAYMENT_OPTIONS = [
  {
    value: 1,
    name: "Boleto Bancário",
    slug: "BOLETO",
    searchable: "BANK_SLIP"
  },
  {
    value: 2,
    name: "Débito Automático",
    slug: "DEBITO_AUTOMATICO",
    searchable: "DEBIT"
  },
  { value: 3, name: "Carnê", slug: "CARNE", searchable: "BOOKLET" }
]

export const STATUS = {
  WAITING_SYNCHRONIZATION: {
    STATUS: "WAITING_SYNCHRONIZATION",
    LABEL: "Aguardando Sincronização",
    status: "Aguardando",
    substatus: "Sincronização",
    type: "awaiting"
  },
  WAITING_CONCLUSION: {
    STATUS: "WAITING_CONCLUSION",
    LABEL: "Aguardando Conclusão",
    status: "Aguardando",
    substatus: "Conclusão",
    type: "awaiting"
  },
  WAITING_TRANSFORMATION: {
    STATUS: "WAITING_TRANSFORMATION",
    LABEL: "Aguardando Transformação",
    status: "Aguardando",
    substatus: "Transformação",
    type: "awaiting"
  },
  FINISHED_TRANSFORMATION: {
    STATUS: "FINISHED_TRANSFORMATION",
    LABEL: "Finalizado Transformação",
    status: "Finalizado",
    substatus: "Transformação",
    type: "finished"
  },
  FINISHED_CANCELED: {
    STATUS: "FINISHED_CANCELED",
    LABEL: "Finalizado Cancelado",
    status: "Finalizado",
    substatus: "Cancelado",
    type: "finished"
  }
}

export const INDICATOR_STATUS = [
  {
    id: 1,
    STATUS: "WAITING_SYNCHRONIZATION",
    LABEL: "Aguardando Sincronização",
    type: "awaiting"
  },
  {
    id: 2,
    STATUS: "WAITING_CONCLUSION",
    LABEL: "Aguardando Conclusão",
    type: "awaiting"
  },
  {
    id: 3,
    STATUS: "WAITING_TRANSFORMATION",
    LABEL: "Aguardando Transformação",
    type: "awaiting"
  },
  {
    id: 4,
    STATUS: "FINISHED_TRANSFORMATION",
    LABEL: "Finalizado Transformação",
    type: "finished"
  },
  {
    id: 5,
    STATUS: "FINISHED_CANCELED",
    LABEL: "Finalizado Cancelado",
    type: "finished"
  }
]

export const STATUS_TO_SYNC = [STATUS.WAITING_SYNCHRONIZATION.STATUS]

export const PERSON_TYPE = {
  INDIVIDUAL: "FISICA",
  LEGAL: "JURIDICA"
}

export const ADDRESS_TYPE = {
  RESIDENTIAL: "RESIDENCIAL",
  COMMERCIAL: "COMERCIAL"
}

export const PAYMENT_TYPE_OPTION = {
  BILLET: "BOLETO",
  DEBIT: "DEBITO_AUTOMATICO",
  BOOKLET: "CARNE"
}

export const PAYMENT_METHOD = {
  BILLET: "BOLETO",
  DEBIT: "DEBITO_AUTOMATICO",
  BOOKLET: "CARNE"
}

export const CONTACT_TYPE = {
  EMAIL: "EMAIL",
  CELLPHONE: "CELULAR",
  LANDLINE: "FIXO",
  ANOTHER_CONTACT: "CELULAR_ALTERNATIVO"
}

export const SHIPPING_TYPES = [
  {
    value: 1,
    text: "Papel",
    name: "Papel",
    parameter: "PAPEL",
    searchable: "PAPER",
    slug: "PAPEL"
  },
  {
    value: 2,
    text: "E-mail",
    name: "E-mail",
    parameter: "EMAIL",
    searchable: "EMAIL",
    slug: "EMAIL"
  },
  {
    value: 3,
    text: "Entrega Presencial",
    name: "Entrega Presencial",
    parameter: "PRESENCIAL",
    slug: "PRESENCIAL",
    searchable: "PRESENCIAL"
  }
]

export const ALGAR_CODE = "ALG"
export const CABONNET_CODE = "CAB"
